<template>
    <nav
        class="min-w-full py-1 select-none"
        aria-label="Filter"
    >
        <div
            v-if="overlay === true && tagsConfig.show === true"
            class="pointer-events-auto fixed inset-0 z-[2999] h-screen w-screen cursor-default bg-black opacity-75 dark:opacity-7"
        ></div>
        <div class="wrapper relative flex w-full flex-row items-start rounded-md">
            <button
                v-tippy="t('buttonAddTag')"
                type="button"
                :class="[
                    tagsConfig.suggested.length === 0
                        ? 'border-gray-200 text-gray-300'
                        : 'border-gray-400 text-gray-600 hover:border-blue-400 hover:text-blue-600',
                    'mr-2 flex cursor-pointer items-center rounded-sm border bg-white p-px ring-0',
                ]"
                :disabled="tagsConfig.suggested.length === 0"
                @click.prevent="openTagWidget()"
            >
                <MdiPlus
                    class="h-4 w-4"
                    aria-hidden="true"
                />
            </button>
            <div class="flex flex-wrap items-start justify-center gap-2">
                <div
                    v-for="tagExtended in data.extension.TAGS"
                    :key="tagExtended.tag.tagId"
                    class="flex cursor-default items-center justify-center gap-1 rounded-sm border px-2 py-0.5 text-xs font-medium"
                    :style="createTagStyle(tagExtended.tag.color || defaultColor)"
                >
                    <span class="-mt-px">{{ tagExtended.tag.name }}</span>
                    <button
                        v-tippy="t('buttonRemoveTag')"
                        :class="`ml-1 cursor-pointer border-none text-[${tagExtended.tag.color}] bg-transparent hover:opacity-75`"
                        @click.prevent.stop="removeTagAction(data, tagExtended, index)"
                    >
                        <MdiClose class="h-3 w-3" />
                    </button>
                </div>
            </div>
            <Transition
                :show="tagsConfig.show"
                enter-active-class="duration-300 ease-out"
                enter-from-class="transform opacity-0"
                enter-to-class="opacity-100"
                leave-active-class="duration-200 ease-in"
                leave-from-class="opacity-100"
                leave-to-class="transform opacity-0"
            >
                <div
                    v-if="tagsConfig.show"
                    class="absolute top-0 left-0 z-3000"
                    @click.prevent
                >
                    <div class="w-full rounded-md border border-gray-400 bg-white">
                        <div class="w-full p-2">
                            <input
                                id="tag-search"
                                ref="tagger"
                                v-model="tagsConfig.subject"
                                type="text"
                                name="tag-search"
                                class="w-full rounded-md border-0 px-2 py-1.5 text-gray-900 ring-0 placeholder:text-gray-400 focus:ring-0 sm:text-sm"
                                :placeholder="t('tagEnter')"
                                @blur="blur"
                                @focus="filterSuggestions"
                                @click="filterSuggestions"
                                @keyup="filterSuggestions"
                            />
                        </div>
                        <div
                            class="m-0 flex max-h-48 w-full flex-wrap items-start justify-start gap-2 overflow-y-auto p-4"
                        >
                            <div
                                v-for="tag in tagsConfig.suggested"
                                :key="tag.tagId"
                                class="my-2 inline-block"
                                @click.prevent.stop="selectTagAction(data, tag, index)"
                            >
                                <span
                                    class="mr-1 cursor-pointer rounded-sm px-2 py-0.5 text-xs font-medium hover:opacity-75"
                                    :style="createTagStyle(tag.color || defaultColor)"
                                >
                                    {{ tag.name }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </Transition>
        </div>
    </nav>
</template>

<script setup>
import { reactive, ref, nextTick } from 'vue';
import { defaultRemoveTag, defaultAddTag } from '../composables/useTags';
import { createTagStyle, getDefaultColor } from '../composables/useColor';
import { MdiClose, MdiPlus } from 'materialdesignicons-vue3/icons/';

defineExpose({
    name: 'TagAssign',
});

const props = defineProps({
    tags: {
        type: Object,
        default: () => {
            return { items: [], totalCount: 0 };
        },
    },
    selectTagAction: {
        type: Function,
        default: defaultRemoveTag,
    },
    removeTagAction: {
        type: Function,
        default: defaultAddTag,
    },
    data: {
        type: Object,
        default: () => {
            return {};
        },
    },
    overlay: {
        type: Boolean,
        default: () => {
            return true;
        },
    },
    index: {
        type: Number,
        default: 0,
    },
});

const data = props.data;
const tags = props.tags;
const selectTagAction = props.selectTagAction;
const removeTagAction = props.removeTagAction;
const index = props.index;
const tagger = ref(null);

const tagsConfig = reactive({
    subject: '',
    suggested: tags.items,
    show: false,
});

/*
. Dev state
*/
const blur = () => {
    tagsConfig.show = false;
};

const openTagWidget = () => {
    tagsConfig.show = true;
    nextTick(() => {
        tagger.value.focus();
    });
};

const defaultColor = getDefaultColor();

const filterSuggestions = () => {
    tagsConfig.suggested = [];
    tags.items.map((item) => {
        const src = item.name.toLowerCase(),
            search = tagsConfig.subject.toLowerCase();

        if (src.includes(search)) {
            tagsConfig.suggested.push(item);
        }
    });
};
</script>
